import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map, throwError } from 'rxjs';
import { ConfigService } from 'src/app/services/auth/config.service';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

    constructor(private http: HttpClient, private configService: ConfigService, private router: Router) { }

   GetBasicDetailsAdmin() {
      const apiUrl = `${this.configService.getApiUrl()}/Admin/GetBasicDetailsAdmin`;
      return this.http.get<any>(apiUrl).pipe(
        map((response) => {
          return response;
        }),
        catchError((err) => {
          return throwError(() => new Error('Retrieved Data failed.'));
        })
      );
    }
    
     GetDistrictSocietyDetail() {
      const apiUrl = `${this.configService.getApiUrl()}/Admin/GetDistrictSocietyDetail`;
      return this.http.get<any>(apiUrl).pipe(
        map((response) => {
          return response;
        }),
        catchError((err) => {
          return throwError(() => new Error('Retrieved Data failed.'));
        })
      );
    }

    getUserCount() {
    const apiUrl = `${this.configService.getApiUrl()}/Admin/GetUserCountDistrictAndRoleWise`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Data retrieval failed.'));
      })
    );
  }

  CreateNotification(formData: FormData) {
  const apiUrl = `${this.configService.getApiUrl()}/Admin/CreateNotification`;

  return this.http.post<any>(apiUrl, formData).pipe(
    map((response) => {
      return response;
    }),
    catchError((err) => {
      return throwError(() => new Error('Create Notification failed.'));
    })
  );
}

UpdateNotification(formData: FormData) {
  const apiUrl = `${this.configService.getApiUrl()}/Admin/UpdateNotification`;

  return this.http.post<any>(apiUrl, formData).pipe(
    map((response) => {
      return response;
    }),
    catchError((err) => {
      return throwError(() => new Error('Update Notification failed.'));
    })
  );
}

DeleteNotification(id: number) {

  const apiUrl =
    `${this.configService.getApiUrl()}/Admin/DeleteNotification/${id}`;

  return this.http.get<any>(apiUrl).pipe(
    map((response) => {
      return response;
    }),
    catchError((err) => {
      return throwError(() => new Error('Delete Notification failed.'));
    })
  );
}
GetNotifications() {
  const apiUrl = `${this.configService.getApiUrl()}/Admin/GetNotifications`;

  return this.http.get<any>(apiUrl).pipe(
    map((response) => {
      return response;
    }),
    catchError((err) => {
      return throwError(() => new Error('Retrieved Data failed.'));
    })
  );
}

saveTelephonicDirectory(model: any) {
  const apiUrl = `${this.configService.getApiUrl()}/Admin/SaveTelephonicDirectory`;

  return this.http.post<any>(apiUrl, model).pipe(
    map((response) => {
      return response;
    }),
    catchError((err) => {
      return throwError(() => new Error('Save Telephonic Directory failed.'));
    })
  );
}

getTelephonicDirectory() {
  const apiUrl = `${this.configService.getApiUrl()}/Admin/GetTelephonicDirectory`;

  return this.http.get<any>(apiUrl).pipe(
    map((response) => {
      return response;
    }),
    catchError((err) => {
      return throwError(() => new Error('Retrieved Data failed.'));
    })
  );
}

deleteTelephonicDirectory(id: number) {
  const apiUrl = `${this.configService.getApiUrl()}/Admin/DeleteTelephonicDirectory?Id=${id}`;

  return this.http.post<any>(apiUrl, {}).pipe(
    map((response) => {
      return response;
    }),
    catchError((err) => {
      return throwError(() => new Error('Delete Telephonic Directory failed.'));
    })
  );
}

saveProcedure(model: any) {
  const apiUrl = `${this.configService.getApiUrl()}/Admin/SaveProcedure`;

  return this.http.post<any>(apiUrl, model).pipe(
    map((response) => {
      return response;
    }),
    catchError((err) => {
      return throwError(() => new Error('Save Procedure failed.'));
    })
  );
}

getProcedure() {
  const apiUrl = `${this.configService.getApiUrl()}/Admin/GetProcedure`;

  return this.http.get<any>(apiUrl).pipe(
    map((response) => {
      return response;
    }),
    catchError((err) => {
      return throwError(() => new Error('Retrieved Data failed.'));
    })
  );
}

deleteProcedure(id: number) {
  const apiUrl = `${this.configService.getApiUrl()}/Admin/DeleteProcedure?Id=${id}`;

  return this.http.post<any>(apiUrl, {}).pipe(
    map((response) => {
      return response;
    }),
    catchError((err) => {
      return throwError(() => new Error('Delete Procedure failed.'));
    })
  );
}

GetApprovedPanelAuditors() {
  const apiUrl = `${this.configService.getApiUrl()}/Admin/GetApprovedPanelAuditors?ts=${Date.now()}`;

  return this.http.get<any>(apiUrl).pipe(
    map((response) => {
      return response;
    }),
    catchError((err) => {
      return throwError(() => new Error('Retrieved Data failed.'));
    })
  );
}

SaveApprovedPanelAuditor(model: any) {
  const apiUrl = `${this.configService.getApiUrl()}/Admin/SaveApprovedPanelAuditor`;

  return this.http.post<any>(apiUrl, model).pipe(
    map((response) => {
      return response;
    }),
    catchError((err) => {
      return throwError(() => new Error('Save Approved Panel Auditor failed.'));
    })
  );
}

DeleteApprovedPanelAuditor(model: any) {
  const apiUrl = `${this.configService.getApiUrl()}/Admin/DeleteApprovedPanelAuditor`;

  return this.http.post<any>(apiUrl, model).pipe(
    map((response) => {
      return response;
    }),
    catchError((err) => {
      return throwError(() => new Error('Delete Approved Panel Auditor failed.'));
    })
  );
}

getApprovedPanelDocumentUrl(path: string): string {
  if (!path) {
    return '';
  }
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  const normalized = path.replace(/\\/g, '/').replace(/^\/+/, '');
  const apiRoot = this.configService.getApiUrl().replace(/\/api\/?$/i, '');
  if (normalized.indexOf('auditorsDocs') >= 0) {
    const fileName = normalized.split('/').filter(Boolean).pop() || '';
    return `${apiRoot}/assets/auditorsDocs/${fileName}`;
  }
  return `${apiRoot}/UploadedFiles/${normalized}`;
}

GetDevelopmentalFunctions() {
  const apiUrl = `${this.configService.getApiUrl()}/Admin/GetDevelopmentalFunctions?ts=${Date.now()}`;
  return this.http.get<any>(apiUrl).pipe(
    map((response) => response),
    catchError(() => throwError(() => new Error('Retrieved Data failed.')))
  );
}

GetRegulatoryFunctions() {
  const apiUrl = `${this.configService.getApiUrl()}/Admin/GetRegulatoryFunctions?ts=${Date.now()}`;
  return this.http.get<any>(apiUrl).pipe(
    map((response) => response),
    catchError(() => throwError(() => new Error('Retrieved Data failed.')))
  );
}

GetAllDepartmentFunctions() {
  const apiUrl = `${this.configService.getApiUrl()}/Admin/GetAllDepartmentFunctions?ts=${Date.now()}`;
  return this.http.get<any>(apiUrl).pipe(
    map((response) => response),
    catchError(() => throwError(() => new Error('Retrieved Data failed.')))
  );
}

SaveFunctionCategory(model: any) {
  const apiUrl = `${this.configService.getApiUrl()}/Admin/SaveFunctionCategory`;
  return this.http.post<any>(apiUrl, model).pipe(
    map((response) => response),
    catchError((err) => throwError(() => err))
  );
}

SaveFunctionPoint(model: any) {
  const apiUrl = `${this.configService.getApiUrl()}/Admin/SaveFunctionPoint`;
  return this.http.post<any>(apiUrl, model).pipe(
    map((response) => response),
    catchError((err) => throwError(() => err))
  );
}

DeleteFunctionCategory(model: any) {
  const apiUrl = `${this.configService.getApiUrl()}/Admin/DeleteFunctionCategory`;
  return this.http.post<any>(apiUrl, model).pipe(
    map((response) => response),
    catchError(() => throwError(() => new Error('Delete Function Category failed.')))
  );
}

DeleteFunctionPoint(model: any) {
  const apiUrl = `${this.configService.getApiUrl()}/Admin/DeleteFunctionPoint`;
  return this.http.post<any>(apiUrl, model).pipe(
    map((response) => response),
    catchError(() => throwError(() => new Error('Delete Function Point failed.')))
  );
}

  groupDepartmentFunctionRows(rows: any[]): any[] {
    if (!rows || rows.length === 0) {
      return [];
    }
    if (rows[0].functionPoints || rows[0].FunctionPoints) {
      return rows;
    }

    const grouped: any[] = [];
    const byId: { [key: string]: any } = {};

    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      const id = Number(row.categoryId ?? row.CategoryId ?? 0);
      if (!id) {
        continue;
      }
      const key = String(id);
      if (!byId[key]) {
        const cat = {
          categoryId: id,
          categoryName: row.categoryName ?? row.CategoryName,
          functionType: row.functionType ?? row.FunctionType,
          sectionTitle: row.sectionTitle ?? row.SectionTitle,
          heading: row.heading ?? row.Heading,
          footerText: row.footerText ?? row.FooterText,
          displayOrder: row.categoryDisplayOrder ?? row.CategoryDisplayOrder ?? row.displayOrder ?? row.DisplayOrder,
          isActive: row.isActive ?? row.IsActive,
          functionPoints: []
        };
        byId[key] = cat;
        grouped.push(cat);
      }

      const pointId = row.pointId ?? row.PointId;
      if (pointId) {
        byId[key].functionPoints.push({
          pointId: pointId,
          pointText: row.pointText ?? row.PointText,
          pointType: row.pointType ?? row.PointType,
          displayOrder: Number(row.pointOrder ?? row.PointOrder ?? 0),
          isActive: row.pointIsActive ?? row.PointIsActive
        });
      }
    }

    grouped.sort((a, b) => Number(a.displayOrder || 0) - Number(b.displayOrder || 0));
    return grouped;
  }

  getRtiOfficers() {
    const apiUrl = `${this.configService.getApiUrl()}/Admin/GetRtiOfficers`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );
  }

  saveRtiOfficer(model: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Admin/SaveRtiOfficer`;
    return this.http.post<any>(apiUrl, model).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Save RTI officer failed.'));
      })
    );
  }

  deleteRtiOfficer(id: number) {
    const apiUrl = `${this.configService.getApiUrl()}/Admin/DeleteRtiOfficer?Id=${id}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Delete RTI officer failed.'));
      })
    );
  }

  getRtiDuties() {
    const apiUrl = `${this.configService.getApiUrl()}/Admin/GetRtiDuties?ts=${Date.now()}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => response),
      catchError(() => throwError(() => new Error('Retrieved RTI duties failed.')))
    );
  }

  saveRtiDutyHeading(model: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Admin/SaveRtiDuty`;
    return this.http.post<any>(apiUrl, model).pipe(
      map((response) => response),
      catchError((err) => throwError(() => err))
    );
  }

  saveRtiDutyPoint(model: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Admin/SaveRtiDutyPoint`;
    return this.http.post<any>(apiUrl, model).pipe(
      map((response) => response),
      catchError((err) => throwError(() => err))
    );
  }

  deleteRtiDuty(model: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Admin/DeleteRtiDuty`;
    return this.http.delete<any>(apiUrl, { body: model }).pipe(
      map((response) => response),
      catchError(() => throwError(() => new Error('Delete RTI duty failed.')))
    );
  }


  // Action Paln Module Api Consume

  getAllActionPlanPages() {
    const apiUrl = `${this.configService.getApiUrl()}/Admin/GetAllActionPlanPages?ts=${Date.now()}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => response),
      catchError(() => throwError(() => new Error('Retrieved Action Plan pages failed.')))
    );
  }

  getActionPlanPageBySlug(pageSlug: string) {
    const apiUrl = `${this.configService.getApiUrl()}/Admin/GetActionPlanPageBySlug/${encodeURIComponent(pageSlug)}?ts=${Date.now()}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => response),
      catchError(() => throwError(() => new Error('Retrieved Action Plan page failed.')))
    );
  }

  /** Admin section list — includes IsActive (unlike GetPageBySlug section rows). */
  getActionPlanSectionsByPageId(pageId: number) {
    const apiUrl = `${this.configService.getApiUrl()}/Admin/GetActionPlanSectionsByPageId/${pageId}?ts=${Date.now()}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => response),
      catchError(() => throwError(() => new Error('Retrieved Action Plan sections failed.')))
    );
  }

  saveActionPlanPage(model: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Admin/SaveActionPlanPage`;
    return this.http.post<any>(apiUrl, model).pipe(
      map((response) => response),
      catchError((err) => throwError(() => err))
    );
  }

  saveActionPlanSection(model: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Admin/SaveActionPlanSection`;
    return this.http.post<any>(apiUrl, model).pipe(
      map((response) => response),
      catchError((err) => throwError(() => err))
    );
  }

  deleteActionPlanSection(model: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Admin/DeleteActionPlanSection`;
    return this.http.delete<any>(apiUrl, { body: model }).pipe(
      map((response) => response),
      catchError(() => throwError(() => new Error('Delete Action Plan section failed.')))
    );
  }
}
